import React from 'react';
import {createStyles, makeStyles, Theme} from '@material-ui/core';

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  text: {
    color: palette.error.main,
    fontSize: '12px',
  },
}), { name: 'Error' });

type Props = {
  className?: string;
  children: React.ReactNode;
};

const Error = ({
  className,
  children,
}: Props) => {
  const classes = useStyles();

  if (!children) {
    return null;
  }

  return (
    <div className={className}>
      <span className={classes.text}>{children}</span>
    </div>
  );
};

export default Error;
